<template>
  <EmptyResourceNotification v-if="!mediaPath" :resource="resource" />
  <Media
    v-else
    :path="mediaPath"
    :autoplay="resource.columns.autoplay"
    :controls="resource.columns.controls"
    :small="resource.columns.small"
  />
</template>

<script>
import EmptyResourceNotification from 'beisheim/components/elements/empty-resource-notification'
import editable from '@i22/frontend-cms-utils/mixins/editable'
import Media from 'beisheim/components/elements/media'

export default {
  components: {
    Media,
    EmptyResourceNotification
  },
  mixins: [ editable ],
  computed: {
    mediaPath () {
      return this.resource.columns.video || this.resource.columns.path
    }
  },
  methods: {
    isSet (prop) {
      return prop !== undefined && prop !== null
    }
  }
}
</script>
